module.exports = __webpack_public_path__ + "bd5c1775f9276776b87f3eb3755b1fa3.svg";